export default __webpack_public_path__ + "static/media/avatar_28.edc9cce3.png";